import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type HasPhotosSubscriptionQueryVariables = Types.Exact<{
  eventId: Types.Scalars['String'];
  featureType: Types.JoyFeatureType;
}>;

export type HasPhotosSubscriptionQuery = { __typename?: 'Query'; hasJoyFeatureSubscription: boolean };

export const HasPhotosSubscriptionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HasPhotosSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'featureType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'JoyFeatureType' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasJoyFeatureSubscription' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'featureType' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'featureType' } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useHasPhotosSubscriptionQuery__
 *
 * To run a query within a React component, call `useHasPhotosSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasPhotosSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasPhotosSubscriptionQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      featureType: // value for 'featureType'
 *   },
 * });
 */
export function useHasPhotosSubscriptionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HasPhotosSubscriptionQuery, HasPhotosSubscriptionQueryVariables>) {
  return ApolloReactHooks.useQuery<HasPhotosSubscriptionQuery, HasPhotosSubscriptionQueryVariables>(HasPhotosSubscriptionDocument, baseOptions);
}
export function useHasPhotosSubscriptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HasPhotosSubscriptionQuery, HasPhotosSubscriptionQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<HasPhotosSubscriptionQuery, HasPhotosSubscriptionQueryVariables>(HasPhotosSubscriptionDocument, baseOptions);
}
export type HasPhotosSubscriptionQueryHookResult = ReturnType<typeof useHasPhotosSubscriptionQuery>;
export type HasPhotosSubscriptionLazyQueryHookResult = ReturnType<typeof useHasPhotosSubscriptionLazyQuery>;
export type HasPhotosSubscriptionQueryResult = Apollo.QueryResult<HasPhotosSubscriptionQuery, HasPhotosSubscriptionQueryVariables>;
